module.exports = __webpack_public_path__ + "img/sweat_smile.b158df66.png";